/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import { Observable } from "rxjs";
import { AuthProviders } from "./auth/AuthProviders";

import ApiConfig from "./ApiConfig";

import CompanyDataProvider from "./company/CompanyDataProvider";
import CpeDataProvider from "./cpe/CpeDataProvider";
import Auth from "./auth/Auth";


/**
 * Current API status
 */
export enum ApiStatus {
   NotInitialized,
   Initializing,
   Error,
   Ready
}


/**
 * Available API HTTP Methods
 */
export type HttpMethod = "GET" | "POST" | "PUT" | "DELETE";


/**
 * Interface providing the basic information about
 * the API availabe and providing common API methods
 */
export default interface Api {

   /** API configuration */
   readonly config: ApiConfig;

   /** API status */
   readonly status: ApiStatus;

   /** API version returned from the server */
   readonly version: string;

   /** API Copyright message returned from the server */
   readonly copyright: string;

   /** CSRF token returned from server and to be used within all API calls */
   readonly csrf_token: string;

   /** Currently looged in user */
   readonly user_id: string | null;

   /** List of roles assigned to currently logger user */
   readonly user_roles: string[];

   /** Auth session exspiration info  */
   readonly auth_expires: number;

   /** Client side authentication providers configuration */
   readonly auth_providers: AuthProviders;

   readonly auth: Auth | null;

   readonly cpeDataProvider: CpeDataProvider;

   readonly companyDataProvider: CompanyDataProvider;

   /**
    * Initializes API.
    * Calls /api/info and collects all information provided by server.
    * Should be called and awaited when the application is being initialized.
    */
   initAsync(): Promise <void>;

   /**
    * Performs an API call. Setups the AJAX call according to
    * requirements andconfiguration i.e. adds CSRF token and so on.
    * It is expected that all API calls returns 200 if the request
    * is served successfully. Otherwise an error is thrown. This method
    * should be used by all API calls.
    * @param endpoint API endpoint to call
    * @param search Object containing search arguments (behind path in url, after ? mark)
    * @param method Method to be used (valid methods are GET, POST, PUT, DELETE)
    * @param data Data to be passed in the body (i.e. JSON object)
    */
   call<RequestBody = any, ResponseBody = any>(endpoint: string, search?: any, method?: HttpMethod, data?: RequestBody): Observable<ResponseBody>

}